import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6262a4c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ja" }, "日本語", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { computed } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const i18n = useI18n();

const locale = computed({
  get() {
    return i18n.locale.value;
  },
  set(newLocale: string) {
    i18n.locale.value = newLocale;
    const url = new URL(location.href);
    url.searchParams.set("l", newLocale);
    history.pushState({}, "", url);
  },
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null))
  }, _hoisted_3, 512)), [
    [_vModelSelect, _unref(locale)]
  ])
}
}

})